import * as React from 'react'
import { FooterMenuTriggerButton } from './FooterMenuTriggerButton'
import { Locale, TranslateFunction } from '@ds/base'
import { TranslationKeys } from '@ds/comp-private'
import { Menu } from '@ds/ui'
import { getDisplayName, sortedLocaleAndDisplayName } from './localeDisplay'

interface FooterLanguageSelectorProps {
  locales: Locale[]
  currentLocale: Locale
  translate: TranslateFunction<TranslationKeys>
  onLocaleSelected: (locale: Locale) => void
  menuButtonDataQa: string
  onMenuOpened?: () => void
}

export const FooterLanguageSelector: React.FunctionComponent<
  FooterLanguageSelectorProps
> = (props) => {
  const localeDescriptions = sortedLocaleAndDisplayName(props.locales)

  return (
    <div>
      <Menu.Button>
        {({
          buttonOnClick,
          buttonOnKeyDown,
          buttonRef,
          menuVisible,
          menuAnchor,
          menuRef,
          menuItemOnKeyDown,
          menuItemEventHandler,
          menuOnVisible,
        }) => (
          <>
            <FooterMenuTriggerButton
              text={getDisplayName(props.currentLocale)}
              data-qa={props.menuButtonDataQa}
              currentLocale={props.currentLocale}
              onClick={buttonOnClick}
              onKeyDown={buttonOnKeyDown}
              forwardedRef={buttonRef}
            />
            <Menu
              visible={menuVisible}
              anchor={menuAnchor}
              forwardedRef={menuRef}
              onVisible={() => {
                menuOnVisible()
                props.onMenuOpened && props.onMenuOpened()
              }}
              maxHeight="calc(100dvh - 80px)"
            >
              <Menu.Group
                accessibilityTitle={props.translate('Aria-language-selector')}
              >
                {localeDescriptions.map((langAndName) => (
                  <Menu.Item
                    data-qa={`language-selection-${langAndName.locale}`}
                    onClick={menuItemEventHandler((_evt, closeMenu) => {
                      if (props.currentLocale !== langAndName.locale) {
                        props.onLocaleSelected(langAndName.locale)
                      }
                      closeMenu()
                    })}
                    onKeyDown={menuItemOnKeyDown}
                    role="menuitemradio"
                    selected={props.currentLocale === langAndName.locale}
                    key={langAndName.locale}
                    text={langAndName.displayName}
                    lang={langAndName.locale}
                  />
                ))}
              </Menu.Group>
            </Menu>
          </>
        )}
      </Menu.Button>
    </div>
  )
}
